var map = {
	"./company.svg": "eb7e",
	"./competition.svg": "6eb8",
	"./customers.svg": "4908",
	"./logo.png": "cf05",
	"./madelogo.png": "2aff",
	"./people.svg": "19b0",
	"./place.svg": "1251",
	"./price.svg": "39d8",
	"./product.svg": "4e66",
	"./promotion.svg": "6c24"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";